import { defineStore } from "pinia";
import { ref } from "vue";
import { listProjects } from "@/api/projects";
import type { ApiError, ProjectListItem } from "@/api/types";
import { useApi } from "@/composables/useApi";

export const useProjectsStore = defineStore("projects", () => {
  const items = ref<ProjectListItem[]>([]);
  const loading = ref(false);
  const error = ref<ApiError | null>(null);
  let lastLoadedAt = 0;

  async function load(force = false): Promise<void> {
    // Cache for 60s — switching tabs shouldn't refetch.
    if (!force && Date.now() - lastLoadedAt < 60_000 && items.value.length > 0) return;
    const { client } = useApi();
    loading.value = true;
    error.value = null;
    try {
      items.value = await listProjects(client);
      lastLoadedAt = Date.now();
    } catch (err) {
      error.value = err as ApiError;
    } finally {
      loading.value = false;
    }
  }

  return { items, loading, error, load };
});
